<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <WiringsRegister/>

    </transition>
  </div>
</template>

<script>

import WiringsRegister from '@/components/register/WiringsRegister.vue'

export default {
  name: 'Entries',
  components: {
    WiringsRegister
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
